<div class="panel panel-default">
  <div class="panel-body">
    <label class="btn btn-secondary btn-file btn-block">
      Choose file
      <input #fileSelector class="hidden" type="file" accept="{{ fileTypeFilter }}" (change)="onAfterFileSelected($event)" />
    </label>
    <ng-content></ng-content>
  </div>
</div>